import React, { useEffect } from "react";
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel";
import home1 from "../../../component/img/home-1.png";
import home2 from "../../../component/img/home-2.png";
import home3 from "../../../component/img/home-3.png";
import home4 from "../../../component/img/home-4.png";
import { Link } from "react-router-dom";

function PackageSlick() {
    useEffect(() => {
      // Wait for DOM to fully load before initializing Slick
      const initializeSlick = () => {
        const slider = $(".slider-all");
        if (slider.length > 0 && slider.hasClass("slick-initialized") === false) {
          slider.slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
              {
                breakpoint: 768, // For screen widths <= 768px
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          });
        }
      };
  
      // Initialize Slick once DOM is ready
      const timer = setTimeout(() => {
        initializeSlick();
      }, 300);
  
      // Cleanup: Destroy Slick instance on unmount
      return () => {
        clearTimeout(timer);
        const slider = $(".slider-all");
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
      };
    }, []);
  
    return (
      <section>
        <div className="rows tb-space pad-bot-redu tb-space">
          <div className="container">
            <div className="tourz-hom-ser" role="toolbar">
              <ul className="slider-all">
                <li>
                  <div className="hom-quick-acc hom-quick-acc-1">
                    <h2>
                      Book your <span>Travel package</span>
                    </h2>
                    <Link to="/all-package" className="cta-1">
                      Book now
                    </Link>
                    <img src={home1} alt="Travel package" loading="lazy" />
                  </div>
                </li>
                {/* <li>
                  <div className="hom-quick-acc hom-quick-acc-2">
                    <h2>
                      Book your <span>Car Rentals</span>
                    </h2>
                    <a href="booking-car-rentals.html" className="cta-1">
                      Book now
                    </a>
                    <img src={home2} alt="Car Rentals" loading="lazy" />
                  </div>
                </li> */}
                <li>
                  <div className="hom-quick-acc hom-quick-acc-3">
                    <h2>
                      Explore <span>Destinations</span>
                    </h2>
                    <Link to="/all-package" className="cta-1">
                      Explore
                    </Link>
                    <img src={home3} alt="Destinations" loading="lazy" />
                  </div>
                </li>
                <li>
                  <div className="hom-quick-acc hom-quick-acc-4">
                    <h2>
                      Over 30,000+ <span>Hotels</span>
                    </h2>
                    <Link to="all-package" className="cta-1">
                      Book now
                    </Link>
                    <img src={home4} alt="Hotels" loading="lazy" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
  
  export default PackageSlick;